import { Flex, Spin }     from 'antd';
import type { ReactNode } from 'react';

type LoadingPageProps = {
  children?: ReactNode
}

const contentStyle: React.CSSProperties = {
  padding: 50,
  borderRadius: 4,
}

const content = <div style={contentStyle} />

const LoadingPage = ({}: LoadingPageProps) => {
  return (
    <Flex justify="center" align="center" style={{ minHeight: '100vh' }} gap={16} vertical>
      <Spin tip="Loading..." size="large">
        {content}
      </Spin>
    </Flex>
  )
}

export { LoadingPage }
